import RandomNumbers from '~/utils/arrays';
export default {
  name: "ChartDataSetHelperComponent",
  getCountesChartDataSet: function() {
    return [{
        data: [
            10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12,
        ],
        backgroundColor: "#ffffff73",
        fill: false,
    }]
  },
  getDeplicatesChartDataSet: function () {
    return [
        {
            data: [
                10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12,
            ],
            backgroundColor: "#ffffff73",
            fill: false,
            tension: 0.1,
        },
        {
            data: [
                90, 22, 46, 46, 58, 34, 46, 23, 45, 78, 34, 12,
            ],
            backgroundColor: "#ffffff73",
            fill: false,
            tension: 0.1,
        },
    ];
  },
  getCapturesChartDataSet: function () {
    return [
        {
            label: "Today",
            data: [
                100, 90, 54, 46, 58, 70, 46, 23, 45, 78, 34, 12,
            ],
            config: {
                borderColor: "#a1704b",
            },
        },
        {
            label: "Yesterday",
            data: [
                100, 90, 54, 46, 58, 70, 46, 23, 45, 78, 34, 12,
            ],
            config: {
                borderColor: "#d2a17d",
            },
        }
    ];
  },
  getActivityChartDataSet: function () {
    return [
        {
            data: [
                10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12,
            ],
            backgroundColor: "#ffffff73",
            fill: false,
        }
    ];
  },
  getImportsChartDataSet: function () {
    return [
      {
        data: RandomNumbers.randomNumbers(12,100),
        // backgroundColor: "#ffffff73",
        backgroundColor: "#4b54b4",
        borderColor: "#9398d2",
        fill: false,
        tension: 0.1
      },
      {
        data: RandomNumbers.randomNumbers(12,100),
        // backgroundColor: "#ffffff73",
        backgroundColor: "#353b7e",
        borderColor: "#6f76c3",
        fill: false,
        tension: 0.1
      }
    ];
  },
  getOriginChartDataSet: function () {
    return [
      {
        data: RandomNumbers.randomNumbers(12,100),
        backgroundColor: "#ffffff73",
        fill: false,
        tension: 0.1
      },
      {
        data: RandomNumbers.randomNumbers(12,100),
        backgroundColor: "#ffffff73",
        fill: false,
        tension: 0.1
      }
    ];
  },
  getDeliveriesChartDataSet: function () {
    return [
      {
        data: RandomNumbers.randomNumbers(12,100),
        backgroundColor: "#ffffff73",
        fill: false,
        tension: 0.1
      },
      {
        data: RandomNumbers.randomNumbers(12,100),
        backgroundColor: "#ffffff73",
        fill: false,
        tension: 0.1
      }
    ];
  },
  getIntegrationsChartDataSet: function () {
    return [
      {
        data: RandomNumbers.randomNumbers(12,100),
        backgroundColor: "#ffffff73",
        fill: false,
        tension: 0.1
      },
      {
        data: RandomNumbers.randomNumbers(12,100),
        backgroundColor: "#ffffff73",
        fill: false,
        tension: 0.1
      }
    ];
  },
  getFormsChartDataSet: function () {
    return [
      {
        data: RandomNumbers.randomNumbers(12,100),
        // backgroundColor: "#ffffff73",
        backgroundColor: "#4b54b4",
        borderColor: "#9398d2",
        fill: false,
        tension: 0.1
      },
      {
        data: RandomNumbers.randomNumbers(12,100),
        // backgroundColor: "#ffffff73",
        backgroundColor: "#353b7e",
        borderColor: "#262a5a",
        fill: false,
        tension: 0.1
      }
    ];
  }
};
